/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter } from '../../../utils/formatting';

const ShippingInformation = ({
  deliveryItems, saleItems
}) => {
  const {
    isAdmin,
    RL_Name,
    RL_Address,
    RL_City,
    RL_State,
    RL_ShippingAmount,
    RL_ShipppingInfo,
    RL_ShippingMethod,
    RF_Telephone,
    RL_PostalCode,
    redacted,
    locale: { storeCurrency, storeLocale },
  } = useSelector((state) => state);
  const shippingInfo = deliveryItems[0]?.SaleForDelivery?.Delivery;
  const shippingMethod = saleItems.find(
    (item) => item?.Sale?.ItemType === 'Shipping' || item?.SaleForDelivery?.ItemType === 'Shipping'
  );

  const shippingMethodDescription
    = shippingMethod?.Sale?.Descriptions?.[0]?.Text
    || shippingMethod?.SaleForDelivery?.Descriptions?.[0]?.Text
    || '';

  return (
    <>
      <p>*****{RL_ShipppingInfo}*****</p>
      {storeLocale !== 'ko-KR' && (
      <>
        <article className="justify-between">
          <p>{RL_Name}: {isAdmin ? (shippingInfo?.Name?.FullName || '') : redacted}</p><p />
        </article>
        <article className="justify-between">
          <p>{RL_Address}: {isAdmin ? (shippingInfo?.Addresses?.[0]?.AddressLines?.map((line) => line.Line) || '') : redacted}</p>
          <p />
        </article>
        <article className="justify-between">
          <p>{RL_City}: {isAdmin ? (shippingInfo?.Addresses?.[0]?.City || '') : redacted}</p><p />
        </article>
        <article className="justify-between">
          <p>{RL_State}: {isAdmin ? (shippingInfo?.Addresses?.[0]?.StateOrProvince || '') : redacted}</p><p />
        </article>
        <article className="justify-between">
          <p>{RL_PostalCode}: {isAdmin ? (shippingInfo?.Addresses?.[0]?.PostalCode || '') : redacted}</p><p />
        </article>
        <article className="justify-between">
          <p>{RF_Telephone}: {isAdmin ? (shippingInfo?.TelephoneNumbers?.[0]?.Number || '') : redacted}</p><p />
        </article>
      </>
      )}
      <article className="justify-between">
        <p>{RL_ShippingMethod}: {shippingMethodDescription}</p>
      </article>
      <article className="justify-between">
        <p className="pl2-sm">{RL_ShippingAmount}:</p>
        <p>
          {currencyFormatter(
            storeLocale,
            storeCurrency,
            shippingMethod?.Sale?.ActualSalesUnitPrice?.Amount,
          )}
          {shippingMethod?.Sale?.TaxableFlag ? ' T' : ' N'}
        </p>
      </article>
      <br />
    </>
  );
};

ShippingInformation.defaultProps = {
  deliveryItems: [],
  saleItems: [],
};

ShippingInformation.propTypes = {
  deliveryItems: PropTypes.arrayOf(PropTypes.shape()),
  saleItems: PropTypes.arrayOf(PropTypes.shape()),
};

export default ShippingInformation;
